import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const SendIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path
      fillRule="evenodd"
      d="M22.7 1.3a1 1 0 0 1 .24 1.05l-7 19.98a1 1 0 0 1-1.85.08l-3.85-8.65L1.6 9.9a1 1 0 0 1 .08-1.85l19.98-7a1 1 0 0 1 1.06.23Zm-4.5 3.1L4.7 9.1l6.07 2.7 7.41-7.42Zm-6 8.82 7.4-7.41-4.71 13.48-2.7-6.07Z"
      clipRule="evenodd"
    />
  </Icon>
));
export default SendIcon;
